var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-end mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex w-full gap-5 mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-full max-w-lg mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "No. Pesanan, Nama Pengirim / Penerima"
    },
    on: {
      "enter": function ($event) {
        return _vm.doSearch();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)]), _c('div', {
    staticClass: "w-full max-w-xs mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Rentang Tanggal")]), _c('div', {
    staticClass: "date-range relative text-xs"
  }, [_c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 z-1"
  }, [_c('Calendar', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('date-range-picker', {
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": false,
      "timePicker24Hour": false,
      "ranges": false
    },
    on: {
      "update": _vm.setDate
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)])])]), _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex items-center justify-between tab shadow-border-b mdmax:overflow-x-auto"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, _vm._l(_vm.tabList, function (tab, index) {
    var _vm$selectedTab;

    return _c('div', {
      key: 'tab-' + index,
      staticClass: "relative px-6 py-3 cursor-pointer text-center font-medium flex-shrink-0",
      class: [tab.value === ((_vm$selectedTab = _vm.selectedTab) === null || _vm$selectedTab === void 0 ? void 0 : _vm$selectedTab.value) ? 'active text-neutral-700' : 'text-neutral-500'],
      on: {
        "click": function ($event) {
          return _vm.selectTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")]);
  }), 0)]), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {}, _vm._l(_vm.filteredData, function (order) {
    return _c('div', {
      key: order.order_id
    }, [_c('InstantDeliveryCard', {
      attrs: {
        "data": order
      }
    })], 1);
  }), 0) : _c('div', {
    staticClass: "py-10 text-center"
  }, [_vm._v("Data tidak ditemukan!")])]), !_vm.isMobile && _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.queries.page,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.queries.per_page
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }